import Component from 'component';
customElements.define('x-horizontal-scroller', class extends Component {
    constructor() {
        super();
        this.$element.frame = this.querySelector('[data-horizontal-scroller-element="frame"]');
        this.$element.target = this.querySelector('[data-horizontal-scroller-element="target"]');
    }
    transformHandler;
    absOffsetTop = 0;
    currentValue = 0;
    targetValue = 0;
    rafId = null;
    scrollTimelineFallback() {
        if (this.mobileQuery.matches)
            return;
        this.absOffsetTop = this.getBoundingClientRect().top + window.scrollY;
        this.style.setProperty('--horizontal-scroller-root-height', `${this.$element.target?.clientWidth}px`);
        this.transformHandler = this.onScroll.bind(this);
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                window.addEventListener('scroll', this.transformHandler, { passive: true });
                this.startLerp();
            } else {
                window.removeEventListener('scroll', this.transformHandler);
                this.stopLerp();
            }
        }, { threshold: 0.95 });
        observer.observe(this.$element.frame);
    }
    onScroll() {
        const pct = (window.scrollY - this.absOffsetTop) / (this.clientHeight - window.innerHeight) * 100;
        this.targetValue = Math.max(0, Math.min(pct, 100));
    }
    startLerp() {
        if (this.rafId) return;
        const tick = () => {
            this.currentValue += (this.targetValue - this.currentValue) * 0.08;
            if (Math.abs(this.targetValue - this.currentValue) < 0.01) {
                this.currentValue = this.targetValue;
            }
            this.style.setProperty('--horizontal-scroller-scroll-percentage', String(this.currentValue));
            this.rafId = requestAnimationFrame(tick);
        };
        this.rafId = requestAnimationFrame(tick);
    }
    stopLerp() {
        if (this.rafId) {
            cancelAnimationFrame(this.rafId);
            this.rafId = null;
        }
    }
});
